const checkCart = async () => {
  let cartData;

  await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      cartData = response.json();
      return cartData;
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  return cartData;
};

const addEditButtons = async (container) => {
  const cartResponse = await checkCart();
  const cartItems = cartResponse.items.filter((item) => {
    const props = item.properties || {};

    if (props._opt7_canvas !== 'true') return false;

    const hasOtherProps = Object.entries(props).some(
      ([key, value]) => key !== '_opt7_canvas' && value,
    );

    return hasOtherProps;
  });

  if (cartItems.length === 0) return;

  const cartItemsElements = container;

  if (!cartItemsElements) return;

  const cartItemElementsArray = Array.from(
    cartItemsElements.querySelectorAll('[data-live-item-key]'),
  );

  cartItems.forEach((cartItem) => {
    const matchingElement = cartItemElementsArray.find(
      (el) => el.getAttribute('data-live-item-key') === cartItem.key,
    );

    if (!matchingElement) return;

    const editButton = document.createElement('a');
    editButton.href = `/products/${cartItem.handle}?variant=${cartItem.variant_id}&item=${cartItem.key}`;
    editButton.textContent = 'Edit ⚙️';
    editButton.className = 'btn btn--secondary cart-item__edit-button';

    const actionsContainer = matchingElement.querySelector('p.product-option');

    if (actionsContainer) {
      actionsContainer.parentNode.insertBefore(editButton, actionsContainer);
    }
  });
};

window.addEditButtons = addEditButtons;
window.checkCart = checkCart;
